import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'

const RecentTrx = ({data, loading}: {data: any; loading: boolean}) => {
  const intl = useIntl()

  const Columns = [
    {
      key: 'OrderId',
      dataIndex: 'orderId',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.ORDER_ID'}),
    },
    {
      key: 'Amount',
      dataIndex: 'paidAmount',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.AMOUNT'}),
      monetize: true,
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Type',
      dataIndex: 'type',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.TYPE'}),
      render: (text: string) => {
        let color = 'text-success'

        switch (text) {
          case 'Cancel':
            color = 'text-error'
            break
          case 'Refund':
            color = 'text-refund'
            break
          case 'Sales':
            color = 'text-success'
            break
          /*           case 'SignUp':
            color = 'text-signup'
            break
          case 'Birthday':
            color = 'text-info'
            break */
          default:
            color = 'text-regular'
            break
        }

        return <span className={color}>{text}</span>
      },
    },
    {
      key: 'Earned',
      dataIndex: 'pointEarned',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.EARNED'}),
    },
    {
      key: 'redeemed',
      dataIndex: 'pointReedemption',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.REDEEMED'}),
    },
    {
      key: 'reward',
      dataIndex: 'reward',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.REWARD'}),
      render: (text: string) => <>{text ? text : '-'}</>,
    },
  ]

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-4 text-secondary'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.SUB'})}
              </h3>
            </div>
          </div>
        </div>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table loading={loading} dataSource={data} tableName={'Trx'} columns={Columns} />
          </div>
        </div>
      </div>
    </>
  )
}

export default RecentTrx
